import { render, staticRenderFns } from "./ticket-static.vue?vue&type=template&id=1868a77d"
import script from "./ticket-static.vue?vue&type=script&lang=js"
export * from "./ticket-static.vue?vue&type=script&lang=js"
import style0 from "./ticket-static.vue?vue&type=style&index=0&id=1868a77d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports